import {createSelector} from '@reduxjs/toolkit'
import {RootState} from '../types'

const theme = (state: RootState) => state.theme
export const selectNavCollapsed = createSelector(theme, state => state.navCollapsed)
export const selectSideNavTheme = createSelector(theme, state => state.sideNavTheme)
export const selectLocale = createSelector(theme, state => state.locale)
export const selectNavType = createSelector(theme, state => state.navType)
export const selectTopNavColor = createSelector(theme, state => state.topNavColor)
export const selectHeaderNavColor = createSelector(theme, state => state.headerNavColor)
export const selectMobileNav = createSelector(theme, state => state.mobileNav)
export const selectCurrentTheme = createSelector(theme, state => state.currentTheme)
export const selectDirection = createSelector(theme, state => state.direction)
export const selectIsMobile = createSelector(theme, state => state.isMobile)
export const selectCurrency = createSelector(theme, state => state.currency)
